import { FileLocation } from 'appworks/config/asset-config-schema';
import { Layers } from 'appworks/graphics/layers/layers';
import { GMRPreloaderComponent } from 'gaming-realms/components/gmr-preloader-component';

/**
 * Social variation of preloader with no spine.
 *
 * @class SocialPreloaderComponent
 * @typedef {SocialGMRPreloaderComponent}
 * @extends {PreloaderComponent}
 */
export class SocialGMRPreloaderComponent extends GMRPreloaderComponent {
  /**
   * Remove preloader spine, or else it will flash prior to reaching load screen.
   * @override
   * @param {FileLocation[]} files
   */
  public start(files: FileLocation[]): void {
    // TODO: remove preloader as a scene in the first place
    // instead of starting the preloader then quickly trying to delete it
    super.start(files);
    const menuLayer = Layers.get('Menus');
    menuLayer.getSpine('preloader').destroy();
  }
}
